__turbopack_context__.v({
  "chip": "github-stars-module__SluPpq__chip",
  "iconMorph": "github-stars-module__SluPpq__iconMorph",
  "iconOld": "github-stars-module__SluPpq__iconOld",
  "iconStar": "github-stars-module__SluPpq__iconStar",
});
